import React from "react";

interface PerksProps {
  perks: string[];
}

const Perks: React.FC<PerksProps> = ({ perks }) => (
  <section data-section="perks" className="py-8 md:py-12">
    <div className="max-w-3xl mx-auto px-4">
      <h2 className="text-2xl font-bold text-white mb-6 text-center">Play Card Perks</h2>
      <ul className="list-disc list-inside text-white/90 mb-4">
        {perks.map((perk, i) => (
          <li key={i} className="mb-1">{perk}</li>
        ))}
      </ul>
      <div className="flex justify-center">
        <a href="/waiver" className="px-4 py-2 rounded bg-gradient-to-r from-blue-500 to-purple-500 text-white font-semibold shadow" data-cta="playcard">Get Play Card</a>
      </div>
    </div>
  </section>
);

export default Perks;
